export const getLoggedActionType = (action) => {
  if (action.meta && action.meta.requestPhase) {
    const SUFFIX = action.meta.loading ? 'REQUEST' : action.meta.success ? 'SUCCESS' : 'FAILURE';

    return `${action.type}/${SUFFIX}`;
  }

  return action.type;
};
